import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material";
import { Button, ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper, } from "@mui/material";
import React from "react";
export function SplitButton({ buttons, selectedIndex, setSelectedIndex, }) {
    const anchorRef = React.useRef(null);
    const [open, setOpen] = React.useState(false);
    // const [selectedIndex, setSelectedIndex] = React.useState(
    //   buttons.findIndex(button => !getIsDisabled(button))
    // );
    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };
    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };
    const handleClose = (event) => {
        if (anchorRef.current &&
            anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
    };
    const selectedButton = buttons[selectedIndex];
    return (_jsxs(React.Fragment, { children: [_jsxs(ButtonGroup, { variant: "contained", ref: anchorRef, color: "secondary", children: [selectedButton, _jsx(Button, { size: "small", "aria-controls": open ? "split-button-menu" : undefined, "aria-expanded": open ? "true" : undefined, "aria-haspopup": "menu", onClick: handleToggle, children: _jsx(ArrowDropDownIcon, { sx: {
                                transition: "transform 0.2s ease-out",
                                ...(open ? { transform: `rotate(-180deg)` } : undefined),
                            } }) })] }), _jsx(Popper, { open: open, anchorEl: anchorRef.current, role: undefined, transition: true, disablePortal: true, children: ({ TransitionProps, placement }) => (_jsx(Grow, { ...TransitionProps, style: {
                        transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                    }, children: _jsx(Paper, { children: _jsx(ClickAwayListener, { onClickAway: handleClose, children: _jsx(MenuList, { id: "split-button-menu", autoFocusItem: true, children: buttons.map((button, index) => {
                                    return (_jsx(MenuItem, { disabled: getIsDisabled(button), selected: index === selectedIndex, onClick: event => handleMenuItemClick(event, index), children: getInnerText(button) }, index));
                                }) }) }) }) })) })] }));
}
export function getIsDisabled(element) {
    if (typeof element.props.children === "undefined" ||
        typeof element.props.children === "string")
        return element.props.disabled;
    return getIsDisabled(element.props.children);
}
function getInnerText(element) {
    if (typeof element.props.children === "string")
        return element.props.children;
    if (typeof element.props.children === "undefined")
        return element.props.label; // FIXME: this is not a solid solution
    return getInnerText(element.props.children);
}
//# sourceMappingURL=SplitButton.js.map